import React, { memo } from "react";
import { useDrop } from "react-dnd";
import { Overlay, OverlayType } from "./Overlay";
import { ItemTypes } from "./ItemTypes";

export const EditableMenuDropper = memo(function EditableMenuDropper({
  onDrop,
  children,
  depth,
}) {
  const [{ isOver, canDrop }, drop] = useDrop(
    () => ({
      accept: ItemTypes.MENUITEM,
      drop: onDrop,
      collect: (monitor) => ({
        isOver: !!monitor.isOver({ shallow: true }),
        canDrop: !!monitor.canDrop({ shallow: true }),
        // TODO: cannot drop in self
        // TODO: split into two modes (hold shift toggle?) to move self or with children, cannot drop in child if moving with children
      }),
    }),
    []
  );

  return (
    <div
      ref={drop}
      style={{
        position: "relative",
        width: `calc(100% - ${depth * 24}px)`,
        height: 24,
        borderBottom: "1px solid rgb(208, 208, 208)",
        marginLeft: (depth ?? 0) * 24,
      }}
    >
      <div>{canDrop ? children : ""}</div>
      {isOver && !canDrop && <Overlay type={OverlayType.IllegalMoveHover} />}
      {!isOver && canDrop && <Overlay type={OverlayType.PossibleMove} />}
      {isOver && canDrop && <Overlay type={OverlayType.LegalMoveHover} />}
    </div>
  );
});

export default EditableMenuDropper;
